import gql from "graphql-tag";
import { userProfileFragment } from './userProfileFragments'
import { userFragment } from './userFragments'
import { companyFragment } from '@/graphql/company/companyFragments'
import { ratedTagFragment, customTagFragment } from '@/graphql/tag/tagFragments'


export const RESTOREPROFILE = gql`
    mutation restoreUserProfile (
        $userProfileID: ID!
    ){
        restoreUserProfile(
            id: $userProfileID
        ){
            ...userProfileFragment
        }
    }
    ${userProfileFragment}
`

export const DETECTABSENCEERRORS = gql`
    mutation detectAbsenceErrors (
        $userProfileID: ID
        $projectID: ID
    ){
        detectAbsenceErrors(
            userProfileID: $userProfileID
            projectID: $projectID
        ){
            id
            date
        }
    }
`
export const UPDATEMYUSERPROFILE = gql`
    mutation updateMyUserProfile(
        $name: String
        $email: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $phone_work: String
        $phone_mobile: String
        $phone_home: String
        $company_id: ID
        $distance: Int
        $distance_orientation: String
    ){
        updateMyUserProfile(
            input: {
                name: $name
                email: $email
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                phone_work: $phone_work
                phone_mobile: $phone_mobile
                phone_home: $phone_home
                company: {
                    connect : $company_id
                }
                distance: $distance
                distance_orientation: $distance_orientation
            }
        ){
            ...userProfileFragment
            company{
                ...companyFragment
            }
            professions {
                ...ratedTagFragment
            }
            courses {
                ...ratedTagFragment
            }
            skills {
                ...ratedTagFragment
            }
            customTags {
                ...customTagFragment
            }
        }
    }
    ${userProfileFragment}
    ${companyFragment}
    ${ratedTagFragment}
    ${customTagFragment}
`;

export const INVITEUSER = gql`
    mutation inviteUser(
        $name: String!
        $email: String!
        $password: String!
        $password_confirmation: String!
        $role: Role!
    ){
        inviteUser(
            input: {
                name: $name
                email: $email
                password: $password
                password_confirmation: $password_confirmation
                role: $role
            }
        ){
            ...userFragment
            userProfiles{
                data{
                    ...userProfileFragment
                    company{
                        ...companyFragment
                    }
                    professions {
                        ...ratedTagFragment
                    }
                    courses {
                        ...ratedTagFragment
                    }
                    skills {
                        ...ratedTagFragment
                    }
                    customTags {
                        ...customTagFragment
                    }
                }
            }
        }
    }
    ${userFragment}
    ${userProfileFragment}
    ${companyFragment}
    ${ratedTagFragment}
    ${customTagFragment}
`;

export const UPDATEUSERPROFILE = gql`

    mutation updateUserProfile(
        $id: ID!
        $externalID: String
        $name: String
        $email: String
        $title: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $phone_work: String
        $phone_mobile: String
        $phone_home: String
        $company_id: ID
        $hiring_date: Date
        $tags: [ratedTagsConnectInput]
        $distance: Int
        $distance_orientation: String
        $ignore_tracking: Boolean
        $vehicule_available: Boolean
        $vehicules: [upsertResourceInput]
        $absences: [upsertAbsenceInput]
        $deleteVehicule: [ID]
        $deleteAbsences: [ID]
        $role: Role
        $url1: String
        $url2: String
        $internal_notes: String
    ){
        updateUserProfile(
            input: {
                id: $id
                externalID: $externalID
                name: $name
                email: $email
                title: $title
                url1: $url1
                url2: $url2
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                phone_work: $phone_work
                phone_mobile: $phone_mobile
                phone_home: $phone_home
                company: {
                    connect : $company_id
                }
                tags: {
                    connect : $tags
                }
                distance: $distance
                distance_orientation: $distance_orientation
                hiring_date: $hiring_date
                ignore_tracking: $ignore_tracking
                vehicule_available: $vehicule_available
                vehicules: {
                    sync: []
                    upsert: $vehicules
                    delete: $deleteVehicule
                }
                absences: {
                    sync: []
                    upsert: $absences
                    delete: $deleteAbsences
                }
                role: $role
                internal_notes: $internal_notes
            }
        ){
            ...userProfileFragment
            company{
                ...companyFragment
            }
            professions {
                ...ratedTagFragment
            }
            courses {
                ...ratedTagFragment
            }
            skills {
                ...ratedTagFragment
            }
            customTags {
                ...customTagFragment
            }
        }
    }
    ${userProfileFragment}
    ${companyFragment}
    ${ratedTagFragment}
    ${customTagFragment}
`;

export const updateMyAccount = gql`
    mutation updateMyAccount(
        $name: String
        $email: String
        $currentPassword: String
        $newPassword: String
        $newPasswordConfirm: String
    ){
        updateMe(
            name: $name
            email: $email
            currentPassword: $currentPassword
            newPassword: $newPassword
            newPasswordConfirm: $newPasswordConfirm
        ) {
            id
            name
            email
        }
    }
`
export const CHANGEPASSWORD = gql`
    mutation updateMyAccount(
        $currentPassword: String
        $newPassword: String
        $newPasswordConfirm: String
    ){
        updateMe(
            currentPassword: $currentPassword
            newPassword: $newPassword
            newPasswordConfirm: $newPasswordConfirm
        ) {
            id
            name
            email
        }
    }
`
export const RESETPASSWORD = gql`
    mutation resetPassword(
        $email: String!
        $reset_token: String!
        $newPassword: String!
        $newPasswordConfirm: String!
    ){
        resetPassword(
            email: $email
            reset_token: $reset_token
            newPassword: $newPassword
            newPassword_confirmation: $newPasswordConfirm
        ) {
            success
            message
        }
    }
`
export const REQUESTPASSWORDRESET = gql`
    mutation requestPasswordReset(
        $email: String!
    ){
        requestPasswordReset(
            email: $email
        ) {
            success
            message
        }
    }
`

export const DELETEUSERPROFILE = gql`
    mutation deleteUserProfile(
        $id: ID!
    ){
        deleteUserProfile(
            id: $id
        ){
            ...userProfileFragment
        }
    }
    ${userProfileFragment}
`